import { ISearchBy, ISearchByOpts } from '../interfaces/search';
import { DatePicker } from './date-picker';
import SearchRegions from './search-regions';

interface IProps {
  activeModule: string;
  searchBy: ISearchBy;
  onSetSearchBy: (searchBy: ISearchByOpts) => void;
  onChangeModule: (moduleName: string | null) => void;
  handleFormSubmit?: () => void;
}

export function SearchModuleExtension({
  activeModule,
  searchBy,
  onSetSearchBy,
  onChangeModule,
  handleFormSubmit,
}: IProps) {
  const getModuleClass = () => {
    if (activeModule === 'location') {
      return 'pos-start';
    }
    return 'pos-center';
  };

  const getModuleContent = () => {
    if (activeModule === 'startDate' || activeModule === 'endDate') {
      return (
        <DatePicker
          searchBy={searchBy}
          onSetSearchBy={onSetSearchBy}
          onChangeModule={onChangeModule}
          activeModule={activeModule}
          onApply={handleFormSubmit}
        />
      );
    }
    if (activeModule === 'location') {
      return (
        <SearchRegions
          searchBy={searchBy}
          onSetSearchBy={onSetSearchBy}
          onChangeModule={onChangeModule}
        />
      );
    }
    return null;
  };

  return (
    <section className={`search-module-extension ${getModuleClass()}`}>
      {getModuleContent()}
    </section>
  );
}
